export default [
    {
        path: '/invoiceAddPerson', // 电子发票 - 1.填写客票信息
        component: resolve => require(['@/pages/weixinH5/invoice/addPerson.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/fillInvoice', // 电子发票 - 2.填写发票信息
        component: resolve => require(['@/pages/weixinH5/invoice/fillInvoice.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/invoiceMore', // 电子发票 - 2.填写发票信息/更多内容
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceMore.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/invoiceList', // 电子发票 - 我的申请
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceList.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/invoiceDetail', // 电子发票 - 发票详情
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceDetail.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/invoiceSuccess', // 电子发票 - 申请成功
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceSuccess.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/revokeService', // 电子发票 - 入口
        component: resolve => require(['@/pages/weixinH5/invoice/revokeService.vue'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/invoiceHeaderList', // 发票抬头 - 列表
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceHeaderList.vue'], resolve),
        meta: { title: "发票抬头列表" }
    },
    {
        path: '/invoiceHeaderAdd', // 发票抬头 - 添加
        component: resolve => require(['@/pages/weixinH5/invoice/invoiceHeaderAdd.vue'], resolve),
        meta: { title: "发票抬头" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/invoice.js